/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const SweepStatus = {
  Accruing: "accruing",
  ActionRequired: "action-required",
  Canceled: "canceled",
  Closed: "closed",
  Failed: "failed",
  Paid: "paid",
} as const;
export type SweepStatus = ClosedEnum<typeof SweepStatus>;

/** @internal */
export const SweepStatus$inboundSchema: z.ZodNativeEnum<typeof SweepStatus> = z
  .nativeEnum(SweepStatus);
/** @internal */
export const SweepStatus$outboundSchema: z.ZodNativeEnum<typeof SweepStatus> =
  SweepStatus$inboundSchema;
